var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1 23.25H6.9C2.99 23.25 1.25 21.51 1.25 17.6V13.4C1.25 9.49 2.99 7.75 6.9 7.75H11.1C15.01 7.75 16.75 9.49 16.75 13.4V17.6C16.75 21.51 15.01 23.25 11.1 23.25ZM6.9 9.25C3.8 9.25 2.75 10.3 2.75 13.4V17.6C2.75 20.7 3.8 21.75 6.9 21.75H11.1C14.2 21.75 15.25 20.7 15.25 17.6V13.4C15.25 10.3 14.2 9.25 11.1 9.25H6.9Z",
    fill: "#535353"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1 17.25H16C15.59 17.25 15.25 16.91 15.25 16.5V13.4C15.25 10.3 14.2 9.25 11.1 9.25H8C7.59 9.25 7.25 8.91 7.25 8.5V7.4C7.25 3.49 8.99 1.75 12.9 1.75H17.1C21.01 1.75 22.75 3.49 22.75 7.4V11.6C22.75 15.51 21.01 17.25 17.1 17.25ZM16.75 15.75H17.1C20.2 15.75 21.25 14.7 21.25 11.6V7.4C21.25 4.3 20.2 3.25 17.1 3.25H12.9C9.8 3.25 8.75 4.3 8.75 7.4V7.75H11.1C15.01 7.75 16.75 9.49 16.75 13.4V15.75Z",
    fill: "#535353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.b0574b6754fd41699d12f054a4fd44c6.svg";
export { ForwardRef as ReactComponent };